import { lazy, Suspense } from 'react';
import { Outlet, Route } from 'react-router-dom';

import ErrorBoundaryContainer from '../../components/ErrorBoundaryContainer';
import Loading from '../../components/Loading';

import accountRouter from '../account';

const FactoryDashboardComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "factory-floor-dashboard" */ '../../pages/factory-floor-dashboard'
    ),
);

const factoryFloorDashboardRouter = (
  <Route path="factory-floor-dashboard" element={<Outlet />}>
    <Route
      path=":projectId"
      element={
        <Suspense fallback={<Loading />}>
          <ErrorBoundaryContainer
            key="factory-floor-dashboard"
            component={<FactoryDashboardComponent />}
          />
        </Suspense>
      }
    >
      {accountRouter()}
    </Route>
  </Route>
);

export default factoryFloorDashboardRouter;
